import React, { useEffect, useRef, useState } from "react";
import './Footer1.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import logo from '../image/logo.png'; // Your logo path
import isoCert from '../image/iso.png';
import cmmi from '../image/cmmi.png';


const Footer1 = () => {
  // Animate sections on scroll
  const [visibleSections, setVisibleSections] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => [...new Set([...prev, entry.target.dataset.id])]);
          }
        });
      },
      { threshold: 0.3 }
    );

    const sections = containerRef.current.querySelectorAll('.talent-footer-column');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  return (
    <footer className="talent-footer">
      <div className="talent-footer-main container" ref={containerRef}>
        {/* Logo & Description */}
        <div
          className={`talent-footer-column fade-slide-up ${visibleSections.includes("logo") ? "visible" : ""}`}
          data-id="logo"
        >
          <img src={logo} alt="Talent Trek Technologies" className="talent-footer-logo" />
          <p className="talent-footer-description">
            Talent Trek Technologies is an ISO 9001:2015 certified company providing top-notch IT solutions
            with innovation and excellence.
          </p>

        </div>

        {/* About Links */}
        <div
          class="talent-footer-column fade-slide-up delay-1"
          data-id="about"
        >
          <h5 class="talent-footer-title">About Us</h5>
          <ul class="talent-footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            {/* <li><a href="#products">Products</a></li> */}
            <li><a href="/contact">Contact Us</a></li>
             <li><a href="/privacy">Privacy & Policy</a></li>
               <li><a href="/blog">Blog Page</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div
          className={`talent-footer-column fade-slide-up delay-2 ${visibleSections.includes("contact") ? "visible" : ""}`}
          data-id="contact"
        >
          <h5 className="talent-footer-title">Contact Us</h5>
          <p>Novel Office, Marathahalli, Bangalore</p>
          <p>📞 +91- 6364856603</p>
          <p>📧 info@talenttrektechnologies.com</p>
        </div>

        {/* Social Icons */}
        <div
          className={`talent-footer-column social-column fade-slide-up delay-3 ${visibleSections.includes("social") ? "visible" : ""}`}
          data-id="social"
        >
          <h5 className="talent-footer-title">Follow Us</h5>
          <div className="talent-social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://www.instagram.com/talenttrektechnologies/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/talent-trek-technologies" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
          </div>
            <br></br>
          <div className="certifications">
            <img src={isoCert} alt="ISO 9001:2015 Certified" className="iso-badge" />
            <img src={cmmi} alt="CMMI Certified" className="iso-badge" />
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="talent-footer-bottom text-center">
        <p>© 2025 Talent Trek Technologies. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer1;
